import type { DataFeature, DataGeometry, DataLayerStyle } from '../shared/data-layer.js';
import type { DataImage } from '../shared/data-image.js';
import type { SchemaRecord } from '../shared/schema-input.js';
import { isString } from '../shared/runtime-values.js';

export interface RenderableGeoJsonFeature { geometry: DataGeometry | null; properties?: SchemaRecord | null; id?: string | number; visible?: boolean; drawonamapVisibility?: boolean; image?: DataImage; sourceStyle?: Partial<DataLayerStyle>; drawonamapSourceStyle?: Partial<DataLayerStyle> }

function sourceStyle(properties: SchemaRecord): Partial<DataLayerStyle> | undefined {
  const color = properties.color ?? properties.stroke;
  const fillColor = properties.fill ?? properties.fillColor;
  const width = Number(properties.width ?? properties['stroke-width']);
  const opacity = Number(properties.opacity ?? properties['stroke-opacity']);
  const fillOpacity = Number(properties.fillOpacity ?? properties['fill-opacity']);
  const style: Partial<DataLayerStyle> = {};
  if (isString(color) && /^#[0-9a-f]{6}$/i.test(color)) style.color = color;
  if (isString(fillColor) && /^#[0-9a-f]{6}$/i.test(fillColor)) style.fillColor = fillColor;
  if (Number.isFinite(width)) style.width = width;
  if (Number.isFinite(opacity)) style.opacity = opacity;
  if (Number.isFinite(fillOpacity)) style.fillOpacity = fillOpacity;
  return Object.keys(style).length ? style : undefined;
}

export function createRenderFeature(candidateFeature: RenderableGeoJsonFeature, id: string): DataFeature {
  const properties: SchemaRecord = candidateFeature.properties ?? {};
  const feature: DataFeature = {
    id,
    geometry: candidateFeature.geometry,
    properties,
  };
  if (candidateFeature.visible !== undefined) feature.visible = candidateFeature.drawonamapVisibility ?? candidateFeature.visible;
  if (candidateFeature.image) feature.image = candidateFeature.image;
  if (candidateFeature.id !== undefined) feature.sourceKey = candidateFeature.id;
  const importedStyle = candidateFeature.sourceStyle ? { ...sourceStyle(properties), ...candidateFeature.sourceStyle } : sourceStyle(properties);
  if (importedStyle) feature.sourceStyle = candidateFeature.drawonamapSourceStyle ?? importedStyle;
  return feature;
}
